import {
  sortingTable,
} from 'utils/_sort.js'
import {deleteBtnHandler, deleteAction} from 'utils/_delete-invoice.js'


export default (
  selector
) => {

  sortingTable(selector, 'two')


  const selects = document.querySelectorAll('.invoice-list-admin__select');
  selects.forEach((item) => {
    item.addEventListener("change", (event) => {
      let rowElement = event.target.closest('.invoice-list-admin__body-item')
      if (rowElement && rowElement.dataset.id) {
        let openUrl = '/{!_locale}/admin/invoices/{!id}/paid?status=' + event.target.value
        openUrl = openUrl.replaceAll('{!_locale}', (document.documentElement.lang || 'en'))
          .replaceAll('{!id}', rowElement.dataset.id)
        window.location.href = window.location.protocol + "//" + window.location.host + "" + openUrl;
      }

    })
  })


  const invoiceDeleteButtonList = document.querySelectorAll('.invoice-list-admin__delete')
  if( invoiceDeleteButtonList.length ) {
    invoiceDeleteButtonList.forEach((element) => {
      element.addEventListener('click', deleteBtnHandler)
    })
  }

  deleteAction()

}


